import React, { useRef } from "react";
import UseContext from "hooks/useContext";
import ProfileChoice from "components/profileChoice/ProfileChoice";
import useListFillHeight from "pages/createMission/utils/useListFillHeight";
import { INVITED_PROFILE_TYPE } from "pages/createMission/utils/invitedProfiles";

/** "Sélection" tab: every checked profile with its source and rate; unchecking removes it everywhere. */
const SelectionTab = ({ isActive, invitedProfiles, onToggle }) => {
    const { language } = UseContext();
    const label = (key, defaultValue) => language.getValue(`missionCreation.invitation.selection.${key}`, defaultValue);
    const listRef = useRef(null);
    const profiles = Array.isArray(invitedProfiles) ? invitedProfiles : [];
    const listMaxHeight = useListFillHeight(listRef, isActive, profiles.length);

    const sourceDetail = (profile) =>
        profile.type === INVITED_PROFILE_TYPE.PRIVATE_POOL
            ? label("privatePoolDetail", "Votre vivier · tarif réduit")
            : label("jobbizDetail", "Profil Jobbiz · tarif standard");

    return (
        <div
            ref={listRef}
            className={"flex flex-col overflow-y-auto border rounded-lg"}
            style={listMaxHeight ? { maxHeight: listMaxHeight } : undefined}
        >
            {profiles.length > 0 ? (
                profiles.map((profile) => (
                    <ProfileChoice
                        key={`${profile.type}-${profile.id}`}
                        name={profile.name}
                        detail={sourceDetail(profile)}
                        checked
                        onToggle={() => onToggle(profile)}
                    />
                ))
            ) : (
                <p className="px-5 py-8 text-center ft-sm text-gray-500">{label("empty", "Aucun profil sélectionné")}</p>
            )}
        </div>
    );
};

export default SelectionTab;
